module.exports = __webpack_public_path__ + "static/img/banner_solutions_access.897c0eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_access.png
// module id = pEi/
// module chunks = 10